<template>
  <div class="content-padding">
    <div v-if="showContent" class="about-container">
      <h1 class="headline">{{description}}</h1>
      <!-- Is there about content to display -->
      <div v-if="isAbout">
        <!-- Does it overflow and is the modal enabled -->
        <div v-if="isOverflow && enableAboutModal">
          <div class="about-box">
            <div
              class="about-text mdl-card__supporting-text"
              v-html="truncatedAbout" />
            <div @click="emitOpenModal" class="about-link"><a>[Read More]</a></div>        
          </div>
        </div>
        <!-- If no overflow or modal NOT enabled -->
        <div v-else-if="!isOverflow || !enableAboutModal">
          <div class="mdl-card__supporting-text" v-html="about" />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="about-container">
        <h1 class="headline">Submissions for this event are now closed.</h1>
        <div class="mdl-card__supporting-text">The event has passed or is currently in progress. If it's not too late, you may still attend the event in person.</div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    description: {
      type: String,
      default: ''
    },
    about: {
      type: String,
      default: ''
    },
    isClosed: {
      type: Boolean,
      default: false
    },
    isExpired: {
      type: Boolean,
      default: false
    },
    enableAboutModal: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    cleanText() {
      return this.about.replace(/<[^>]*>/g, '');
    },
    showContent() {
      if (!this.isExpired && this.isClosed) {
        return true;
      } else if (!this.isClosed) {
        return true;
      } else {
        return false;
      }
    },
    truncatedAbout() {
      if (this.cleanText.length > 95) {
        return this.cleanText;
      } else {
        return this.about;
      }
    },
    isOverflow() {
      return this.cleanText.length > 95;
    },
    isAbout() {
      // If you enter '' in meeting about, it will evaluate as false
      if (_.isEmpty(this.cleanText) || this.cleanText === '&#39;&#39;') {
        return false;
      }
      return true;
    }
  },
  methods: {
    emitOpenModal() {
      this.$emit('openAboutModal');
    }
  }
};
</script>

<style scoped>
/* Card styles and sections */
.mdl-card__supporting-text {
  padding: 0px;
  width: 100%;
}
.about-container {
  margin-bottom: 25px;
}
.mdl-card__supporting-text {
  margin: 0px;
}
.about-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.about-text.mdl-card__supporting-text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.about-link {
  font-size: 13px;
  min-width: 75px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/MeetingAbout.vue